export default "__VITE_ASSET__DKW_$PmB__"